import { list } from './list';

export const documentRelations = {
  list,
};
